<template>
  <div :class="['page',`fs${fontsize}`]">
    <div class="header">
      <div class="title">
        【{{claimType=='31'?'种植险':'养殖险'}}】理赔客户确认书
      </div>
      <div class="fontsize-ctrl" v-if="!errorPage">
        <div :class="['fontsize-ctrl-btn-left',fontsize<=14?'fontsize-ctrl-btn-disabled':'']" @click="changeFontSize(1)">小</div>
        <div>字体大小({{fontsize}}px)</div>
        <div :class="['fontsize-ctrl-btn-right',fontsize>=25?'fontsize-ctrl-btn-disabled':'']" @click="changeFontSize(2)">大</div>
      </div>
    </div>
    <div class="errorPage" v-if="errorPage">
      {{errorText}}
    </div>
    <div class="content" v-if="!errorPage">
      <div class="content-box">
        <div class="box-title"  :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">保险信息</div>
        </div>
        <div class="content-item">
          保险险种: <span class="val-text">{{ claimData.riskname }}</span>
        </div>
        <div class="content-item">
          保单号码: <span class="val-text">{{ claimData.policyno }}</span>
        </div>
        <div class="content-item">
          报案号码: <span class="val-text">{{ claimData.registno }}</span>
        </div>

        <div class="content-item">
          投保数量: <span class="val-text">{{ claimData.amount }}</span>
        </div>
        <div class="content-item">
          单位保额: <span class="val-text">{{ claimData.unitamount }}元</span>
        </div>
        <div class="content-item">
          保险期限: <span class="val-text">{{ claimData.insureddate }}</span>
        </div>
        <div class="content-item">
          被保险人: <span class="val-text">{{ claimData.insuredname }}</span>
        </div>
      </div>
      <div class="content-box">
        <div class="box-title"  :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">出险信息</div>
        </div>
        <div class="content-item">
          出险地点: <span class="val-text">{{ claimData.damageaddress }}</span>
        </div>
        <div class="content-item">
          出险日期: <span class="val-text">{{ claimData.damagedate }}</span>
        </div>
        <div class="content-item">
          出险原因: <span class="val-text">{{ claimData.damagereason }}</span>
        </div>
        <div class="content-item">
          出险数量: <span class="val-text">{{ claimData.damageamount }}</span>
        </div>
      </div>
      <div class="content-box">
        <div class="box-title"  :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">账户信息</div>
        </div>
        <div class="content-item">
          账户名称: <span class="val-text">{{ claimData.accountname }}</span>
        </div>
        <div class="content-item">
          身份证/机构代码: <span class="val-text">{{ claimData.identifynumber }}</span>
        </div>
        <div class="content-item">
          银行卡号/一折通: <span class="val-text">{{ claimData.bankacount }}</span>
        </div>
      </div>
      <div class="content-box" v-if="claimData.verifyDamageProgressDto">
        <div class="box-title"  :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">出险经过</div>
        </div>
        <div class="content-item" >
          被保险人<span class="val-text">{{ claimData.verifyDamageProgressDto.insuredname }}</span>参保的<span class="val-text">{{ claimData.verifyDamageProgressDto.itemkindname }}</span>因<span class="val-text">{{ claimData.verifyDamageProgressDto.damagereason }}</span>于 <span class="val-text">{{ claimData.verifyDamageProgressDto.damagedate }}</span>出险。该被保险人于<span class="val-text">{{ claimData.verifyDamageProgressDto.reportdate }}</span>向我司报案。
        </div>
        <div class="content-item">
          报案人：<span class="val-text">{{ claimData.verifyDamageProgressDto.reportname }}</span>
        </div>
      </div>
      <div class="content-box" >
        <div class="box-title"  :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">出险列表</div>
        </div>
        <div class="content-item" v-if="claimType=='32'">
          <div class="list-view">
            <table style="min-width: 1000px;width: auto">
              <tr style="height: 30px !important;font-weight: bold;background-color: #24bd6a;color: white">
                <td >序号</td>
                <td >耳标号</td>
                <td >畜龄(日)</td>
                <td >尸长/尸重(cm/kg)</td>
                <td >单位保额</td>
                <td >定损金额</td>
                <td >死因</td>
              </tr>
              <tr v-for="(item,index) in infoList" style="height: 30px !important;background-color: #f7fff4">
                <td >{{ index+1 }}</td>
                <td >{{ item.earlabe?item.earlabe:'-' }}</td>
                <td >{{ item.age?item.age:'-' }}</td>
                <td >-</td>
                <td >{{ item.unitamount?item.unitamount:'-' }}</td>
                <td >{{ item.damageamount?item.damageamount:'-' }}</td>
                <td >{{ item.damagereason?item.damagereason:'-' }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="content-item" v-if="claimType=='31'">
          <div class="list-view">
            <table style="width: 1000px">
              <tr style="height: 30px !important;font-weight: bold;background-color: #24bd6a;color: white">
                <td >标的</td>
                <td >损失面积(亩)</td>
                <td >损失程度</td>
                <td >对应生长期赔付比例</td>
                <td >采收比例</td>
                <td >绝对免赔额(元)</td>
                <td >赔偿金额(元)</td>
              </tr>
              <tr  v-for="(item,index) in infoList"  style="height: 30px !important;background-color: #f7fff4">
                <td >{{ item.itemkindnamel?item.itemkindnamel:'-' }}</td>
                <td >{{ item.lossareal?item.lossareal:'-' }}</td>
                <td >{{ item.lossdegreel?item.lossdegreel:'-' }}%</td>
                <td >{{ item.pfbl?item.pfbl:'-' }}</td>
                <td >{{ item.csbll?item.csbll:'-' }}</td>
                <td >{{ item.jdmpel?item.jdmpel:'-' }}</td>
                <td >{{ item.damageamountl?item.damageamountl:'-' }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="box-title" :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">保险公司查勘定损结果</div>
        </div>
        <div class="content-item" v-if="claimType=='32'&&claimData.verifyCheckInfoDto">
          经兽医部门，保险公司鉴定确认该<span class="val-text">{{ claimData.verifyCheckInfoDto.itemkindname }}</span>因<span class="val-text">{{ claimData.verifyCheckInfoDto.damagereason }}</span>死亡，属于保险责任范围。 养殖户及时将死亡标的进行无害化处理后，保险公司进行理赔。<br>
          理赔计算（理算）公式：<span class="val-text">{{ claimData.verifyCheckInfoDto.computation?claimData.verifyCheckInfoDto.computation:'无' }}</span>赔偿金额
        </div>
        <div class="content-item" v-if="claimType=='32'&&claimData.verifyCheckInfoDto">
          赔款金额：<span class="val-text">{{ claimData.verifyCheckInfoDto.sumpaid?claimData.verifyCheckInfoDto.sumpaid:0 }} 元</span><br>
          金额大写：<span class="val-text">{{ claimData.verifyCheckInfoDto.sumpaidname?claimData.verifyCheckInfoDto.sumpaidname:'零元整' }}</span>
        </div>
        <div class="content-item" v-if="claimType=='32'&&claimData.verifyCheckInfoDto">
          查勘人：<span class="val-text">{{ claimData.verifyCheckInfoDto.checkername?claimData.verifyCheckInfoDto.checkername:'无' }}</span>
        </div>
        <div class="content-item" v-if="claimType=='32'&&claimData.verifyCheckInfoDto">
          理算人：<span class="val-text">{{ claimData.verifyCheckInfoDto.computename?claimData.verifyCheckInfoDto.computename:'无' }}</span>
        </div>


        <div class="content-item" v-if="claimType=='31'&&claimData.verifyCheckInfoDto">
          经查阅气象材料，保险公司鉴定确认该<span class="val-text">{{ claimData.verifyCheckInfoDto.itemkindname }}</span>因<span class="val-text">{{ claimData.verifyCheckInfoDto.damagereason }}</span>受损，属于保险责任范围。 被保险人及时采取补救措施并报案，保险公司进行理赔。<br>
          理赔计算（理算）公式：<span class="val-text">{{ claimData.verifyCheckInfoDto.computation?claimData.verifyCheckInfoDto.computation:'无' }}</span>赔偿金额
        </div>

        <div class="content-item" v-if="claimType=='31'&&claimData.verifyCheckInfoDto">
          赔款金额：<span class="val-text">{{ claimData.verifyCheckInfoDto.sumpaid?claimData.verifyCheckInfoDto.sumpaid:0 }} 元</span><br>
          金额大写：<span class="val-text">{{ claimData.verifyCheckInfoDto.sumpaidname?claimData.verifyCheckInfoDto.sumpaidname:'零元整' }}</span>
        </div>
        <div class="content-item" v-if="claimType=='31'&&claimData.verifyCheckInfoDto">
          查勘人：<span class="val-text">{{ claimData.verifyCheckInfoDto.checkername?claimData.verifyCheckInfoDto.checkername:'无' }}</span>
        </div>
        <div class="content-item" v-if="claimType=='31'&&claimData.verifyCheckInfoDto">
          理算人：<span class="val-text">{{ claimData.verifyCheckInfoDto.computename?claimData.verifyCheckInfoDto.computename:'无' }}</span>
        </div>
      </div>
      <div class="content-box" >
        <div class="box-title" :style="{'height':computeTitleHeight}">
          <div class="box-title-point"></div>
          <div class="box-title-text">声明</div>
        </div>
        <div class="content-item">
          本被保险人对案情无任何虚假陈述，对本《确认书》各项内容及赔款金额确认无异议，同意并接受保险公司按照保险合同进行赔偿，并承诺就此保险事故不再向保险人提出任何其他索赔。
        </div>

      </div>
      <div  class="checkBox">
        <input  :class="['checkBox-input',!hasRead?'no-check':'']"  type="checkbox" id="checkbox" v-model="hasRead" >
        <label  for="checkbox" :class="[!hasRead?'no-check':'']">以上内容我已阅读并且确认无误</label>
      </div>

      <div class="bottom">
<!--        :class="['btn',!hasRead?'btn-disable':'']"-->
        <div class="btn" @click="toSign">签 字 确 认</div>
      </div>

    </div>
    <div class="mask" @click.stop="" v-if="showDialog"></div>
    <div class="dialog"  v-if="showDialog">
      <div class="dialog-content">
        本人已阅读并确认理赔内容无误
      </div>
      <div class="dialog-bottom">
        <div class="dialog-btn close" @click="closeDialog">取消</div>
        <div class="dialog-btn next" @click="dialogNext">签字确认</div>
      </div>
    </div>
  </div>
</template>

<script>
var obj = require("@/api/api.js");
export default {
  name: "clamInfo",
  data(){
    return{
      claimData:{},
      hasRead:false,
      fontsize:16,
      showDialog:false,
      errorPage:false,
      errorText:'',
      policyno:'',
      registno:'',
      infoList:[],
      claimType:'31' //31种植险 32养殖险
    }
  },
  computed: {
    computeTitleHeight() {
      console.log(30 * (1 / 14)*this.fontsize + 'px !important')
      return 30 * (1 / 14)*this.fontsize + 'px !important'
    },
  },
  created() {
    if(this.$route.query.type)this.claimType=this.$route.query.type
      if(this.$route.query.registno){
        this.registno=this.$route.query.registno
        this.queryInfo()
      }else{
        this.errorPage = true
        this.errorText = '无有效业务号'
      }



  },
  methods:{
    computeWith(num) {
      return num * (1 / 14)*this.fontsize + 'px'
    },
    changeFontSize(type){
      if(type==1){ //小
        if(this.fontsize<=14){
          this.fontsize = 14
        }else{
          this.fontsize--
        }
      }else{ //大
        if(this.fontsize>=25){
          this.fontsize = 25
        }else{
          this.fontsize++
        }
      }
    },
    dialogNext(){
      this.showDialog = false
      this.hasRead = true
      setTimeout(()=>{
        this.toSign()
      },300)

    },
    toSign(){
      if(!this.hasRead){
        this.showDialog = true
        return
      }
      this.$router.push({path:'/face/name',query:{
          registno:this.registno,
          policyno:this.policyno,
          type:this.type
        }})
    },
    closeDialog(){
      this.showDialog = false
    },
    queryInfo(){
      this.$http
        .post(obj.queryVerifyInfo, {businessno:this.registno}).then((res) => {
        console.log(res)
        if(res.data.rtnCode=='0000'){
          this.errorPage = false
          this.claimData = res.data
          this.infoList = res.data.verifyReportInfoDto.reportInfoDtoList
          this.policyno =  this.claimData.policyno
          this.$forceUpdate()
        }else{
          this.errorPage = true
          this.errorText = res.data.rtnMsg
        }
        // window.location.href=_res.verification_url
      });
    }
  }
}
</script>

<style lang="scss" scoped >
.page{
  background-color: #e1f9ed;
}
.fs14{
  font-size: 14px;
}
.fs15{
  font-size: 15px;
}
.fs16{
  font-size: 16px;
}
.fs17{
  font-size: 17px;
}
.fs18{
  font-size: 18px;
}
.fs19{
  font-size: 19px;
}
.fs20{
  font-size: 20px;
}
.fs21{
  font-size: 21px;
}
.fs22{
  font-size: 22px;
}
.fs23{
  font-size: 23px;
}
.fs24{
  font-size: 24px;
}
.fs25{
  font-size: 25px;
}
.header{
  width: 100%;
  background-color: #00a74c;
  color: white;
  text-align: center;
  position: fixed;
  top: 0;
  z-index: 10;
  height: auto;
}
.title{
  width: 100%;
  line-height: 40px;
  height: 40px;
}
.fontsize-ctrl{
  width: 100%;
  height: 40px;
  background-color: white;
  color: #00a74c;
  display: flex;
  align-items: center;
  font-size: 16px !important;
  justify-content: space-between;
  .fontsize-ctrl-btn-left{
    width: 80px;
    border-right: 1px solid #96ebbd;
    height: 40px;
    line-height: 40px;
  }
  .fontsize-ctrl-btn-right{
    width: 80px;
    border-left: 1px solid #96ebbd;
    height: 40px;
    line-height: 40px;
  }
  .fontsize-ctrl-btn-left:active,.fontsize-ctrl-btn-right:active{
    background-color: #00a74c;
    color: white;
  }
  .fontsize-ctrl-btn-disabled{
    background-color: #9cddb9;
    color: white;
  }
}
.errorPage{
  font-size: 20px;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  line-height: 100vh;
  text-align: center;
  background: none;
  color: #9f0000;
  font-weight: bold;
  background-color: #e1f9ed;
}
.content{
  margin-top: 90px;
  padding-bottom: 10px;

}
.content-item{
  padding: 2px 8px;
}
.list-view{
  width: 100%;
  overflow: scroll;
  padding-bottom: 20px;
  scrollbar-face-color: #84d415;
  table {
    tr {
      td {
        text-align: center;
      }
    }
  }
}
.checkBox{
  margin-bottom: 80px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  .checkBox-input{
    width: 16px;
    height: 16px;
    /* 隐藏原生checkbox */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: white;
    border: 1px solid #2b9c00;
    border-radius: 3px;
    position: relative;

  }
  .checkBox-input:checked {
    background-color: #2b9c00 !important; /* 选中时的背景颜色 */
  }
  .checkBox-input:checked::after {
    content: '';
    display: block;
    width: 6px;
    height: 12px;
    border: solid white; /* 对勾颜色 */
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 0px;
    left: 4px;
  }
  .checkBox-input.no-check{
    border: 1px solid #ff6c00;
  }
  label {
    padding:  10px 10px 10px 0;
    color: #2b9c00;
  }
  label.no-check{
    color: #ff6c00;
  }
}

.content-box{
  margin: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  padding-bottom: 10px;

  box-shadow: 3px 1px 3px 1px #d9d9d9;
}
.box-title{
  width: 100%;
  /*text-align: center;*/
  height: 30px;
  border-bottom: #d2e7ca 1px solid;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

}
.box-title-point{
  width: 8px;
  height: 8px;
  background: linear-gradient(to bottom, #fb9043, #88e764);
  margin-left: 10px;
  transform: rotate(45deg);
}
.box-title-text{
  margin-left: 10px;
  font-weight: bold;
}
.val-text{
  color: #09b11f;
}
.bottom{
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  background-color: white;
  box-shadow: -1px 0px 7px 0px #9d9d9d;
}
.btn{
  width: calc(100vw - 16px);
  height: 50px;
  background: linear-gradient(to bottom,#87f75c,#2b9c00) ;
  margin-left: 8px;
  color: white;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
  border-radius: 6px;
  //box-shadow: #8bd184 3px 4px 4px;
  margin-top: 5px;
}
.btn-disable{
  background:linear-gradient(to bottom, #d7d7d7, #4f4f4f);
  color: #dbdbdb;
}
.mask{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,.5);
  z-index: 100;
}
.dialog{
  width: 80vw;
  height: 200px;
  position: fixed;
  top: calc((100vh - 200px) / 3);
  left: 10vw;
  background-color: white;
  box-shadow: 1px 1px 5px 2px #bed7ba;
  border-radius: 10px;
  z-index: 101;
  overflow: hidden;
  .dialog-content{
    text-align: center;
    margin-top: 50px;

  }
  .dialog-bottom{
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    display: flex;
    border-top: 1px solid #53d122 ;
    .dialog-btn{
       width: 50%;
      height: 50px;
      text-align: center;
      line-height: 50px;
    }
    .close{
      color: #2b9c00;
    }
    .next{
      background: #2b9c00;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/face/clamInfo.vue